export function emitLoadingStart(context) {
  context.$emit("setLoading", true);
}

export function emitLoadingDone(context, delay = 700) {
  setTimeout(() => {
    context.$emit("setLoading", false);
  }, delay);
}
